/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

// Class that represents the data of the profile of this store

class ProfileReducerData {
  sessionToken : string = '';
}

// Initial State

const initialState : ProfileReducerData = {
  sessionToken: '',
};

// Profile definition

// This reducer will manage the profile and session

export const ProfileReducer = createSlice({
  name: 'ProfileReducer',

  initialState,

  reducers: {
    setSessionToken: (state, action) => {
      state.sessionToken = action.payload.sessionToken;
    },

    clearSessionToken: (state) => {
      state.sessionToken = '';
    },
  },
});
